<div class="conatiner-fluid">
    <div class="row">
        <div class="col-12">
            <mat-icon style="text-align: right;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()" *ngIf="settlementData"> 
                X 
            </mat-icon>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <h3>
                   Settlement Payments History
                </h3>
            </div>
        </div>
        <div class="col-12">
            <div class="card">
                <ag-grid-angular #agGrid 
                        style="width: auto; height: 300px;"
                        class="ag-theme-alpine"
                        [rowData]="PaymentsList"
                        [rowSelection]="'multiple'"
                        [columnDefs]="PaymentscolumnDefs"
                        [pagination]="true">
                </ag-grid-angular>
            </div>
        </div>
    </div>
</div>